import { render, staticRenderFns } from "./AddUpdateFaq.vue?vue&type=template&id=98e742b6"
import script from "./AddUpdateFaq.vue?vue&type=script&lang=js"
export * from "./AddUpdateFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports